import { TranslatePipe } from '../../filters/translate.pipe';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import SymptomCheckService from '../../services/symptom-check.service';
import Session from '../../utils/session.service';
import PreVisitRecordTicketForPersonService from '../../services/pre-visit-record-ticket-for-person.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import moment from 'moment';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'symptom-check-patient',
	templateUrl: './symptom-check-patient.component.html',
	imports: [ CommonModule, TranslatePipe, InputDatepickerNewComponent, ItemErrorComponent, FormsModule ]
})
export class SymptomCheckPatientComponent implements OnInit {
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private session: Session = inject(Session);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() interview: any;
	@Output() interviewChange: EventEmitter<any> = new EventEmitter<any>();
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isRecordTicketForPerson = false;
		this.vm.minDate = new Date(1900, 0, 1);
		
		if (this.vm.interview.birthDate) {
			this.vm.birthDate = this.vm.interview.birthDate;
		} else {
			this.vm.birthDate = new Date();
		}
		
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		if (this.vm.params['type'] === 'pre-visit') {
			this.vm.interview.selfTest = true;
		}
		
		this.vm.user = this.session.getSession().user;
		this.vm.isRecordTicketForPerson = !!this.preVisitRecordTicketForPersonService.getPatient();
		this.vm.handleBack = this.symptomCheckService.prevStep;
		this.vm.handleSubmit = this.handleSubmit;
	};
	
	handleSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid) return;
		
		var selfTest = this.vm.interview.selfTest;
		var sex = this.vm.interview.sex;
		var interview: any = this.symptomCheckService.getInterviewResetTo(2);
		interview.selfTest = selfTest;
		interview.sex = sex;
		this.vm.interview = interview;
		if (!this.vm.interview.selfTest) {
			if (!this.vm.birthDate) {
				this.vm.birthDateInvalid = true;
				return;
			} else {
				this.vm.birthDateInvalid = false;
			}
			
			this.vm.interview.birthDate = this.vm.birthDate;
			var ageInMillis: any = Date.now() - moment(this.vm.birthDate).valueOf();
			if (ageInMillis < 0) {
				this.vm.birthDateInvalid = true;
				return;
			} else {
				this.vm.birthDateInvalid = false;
			}
			var ageInMonths: any = ageInMillis / 2629800000;
			this.vm.interview.age = Math.floor(ageInMonths / 12);
			if (ageInMonths < 36) {
				this.vm.interview.ageInMonths = Math.floor(ageInMonths);
			}
		} else {
			this.vm.interview.age = undefined;
			this.vm.interview.ageInMonths = undefined;
		}
		this.interviewChange.emit(this.vm.interview);
		this.symptomCheckService.nextStep();
	}
	
}